import { Direction } from '@jct/localization';

export const CREDIT_GUARD_TEST_PAYMENT_URL = 'test/credit-guard';
export const CREDIT_GUARD_TEST_PAYMENT_PROVIDER = (standingOrder: boolean = false, layout: Direction = 'rtl') => {
  return `/${CREDIT_GUARD_TEST_PAYMENT_URL}?standingOrder=${standingOrder ? 'true' : 'false'}&layout=${layout ? layout : 'rtl'}`;
};
